if (!customElements.get('featured-products-slider')) {
  // Below 768px this section is NOT a slider at all — it's a plain two-column
  // grid that scrolls with the page (see featured-products.css). Fox, 2026-09-18:
  // "two wide and then scrollable up and down… people are more used to that."
  //
  // Swiper isn't merely configured differently there, it is never constructed:
  // it writes inline width/transform onto the wrapper and every slide, which
  // would override the grid. 768 matches the theme's mobile breakpoint, so the
  // CSS grid and the no-Swiper condition flip at exactly the same width — if
  // you change one, change the other or they overlap.
  const DESKTOP = '(min-width: 768px)';

  class FeaturedProductsSlider extends HTMLElement {
    connectedCallback() {
      this.el = this.querySelector('[data-slider]');
      if (!this.el) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 4,
        spaceBetween: 0,
      };

      this.mq = window.matchMedia(DESKTOP);
      this.sync = this.sync.bind(this);
      this.sync();
      this.mq.addEventListener('change', this.sync);
    }

    disconnectedCallback() {
      if (this.mq) this.mq.removeEventListener('change', this.sync);
      this.teardown();
    }

    sync() {
      if (this.mq.matches) {
        if (!this.slider) this.slider = new Swiper(this.el, this.options);
      } else {
        this.teardown();
      }
    }

    teardown() {
      if (!this.slider) return;
      // (deleteInstance, cleanStyles) — the second flag is the one that matters:
      // it strips the inline styles Swiper left on the wrapper and slides, so
      // the grid takes over cleanly when a rotated phone crosses the breakpoint.
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  customElements.define('featured-products-slider', FeaturedProductsSlider);
}
